import styled from 'styled-components';
import color from '../../constants/color';
import materialUI from '../../material-UI';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-evenly;
  flex-grow: 1;
`;
export const Card = styled(materialUI.Card)`
  display: flex;
  flex-direction: column;
  max-width: 290px;
  min-width: 290px;
  margin: 30px 0px 30px 0px;
`;
export const CardAction = styled.div``;
export const CardImages = styled(materialUI.CardMedia)``;
export const CardContent = styled(materialUI.CardContent)``;
export const CardImage = styled.div`
  display: flex;
  flex-direction: column;
`;
export const OnPress = styled(materialUI.IconButton)``;
export const CardBody = styled.div`
  display: flex;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: Row;
  padding: 16px 10px 0px 10px;
`;
export const Icon = styled.img`
`;
export const TitleCard = styled.div`
  font-family: Inter;
  color: ${color.grey10};
  font-size: 1.2em;
`;
export const SubTitleCard = styled.div`
  font-family: Inter;
  color: ${color.grey10};
  font-size: 0.85em;
  padding: 16px 10px 16px 10px;
`;
export const ContainerLoading = styled.div`
display: flex;
justify-content: center;`;

export const ListDrop = styled.div`
display: flex;
height: 51px;
align-items: center;
padding-left: 16px;
width: 220px;
font-family: Roboto;
cursor: pointer;
padding-right: 10px;
background-color: white;
  :hover {
    background-color: #E1E1E1;
  }
`;
export const Margin = styled.div`
  margin: 10px 20px 20px 40px;
  display: flex;
  width: 100%;
`;
